<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{'!text-red-600': !loading}"
    :text="$t('Hide document')"
    :loading="loading"
    icon="eye-closed"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { DocumentApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import { trackEvent } from '../../gtm'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import handleApiError from '../../utils/handleApiError'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return this.bcDocumentStore.document?.can_edit
        && this.bcDocumentStore.document?.published__bc_document_rev_id === this.bcDocumentStore.document?.bc_document_rev_id
        && this.bcDocumentStore.document?.hidden === null
    },
    ...mapStores(useBcFolderStore),
  },
  methods: {
    async click () {
      this.loading = true
      const documentHideResponse = await handleApiError(() => documentApi.documentHide({ ids: [ this.bcDocumentStore.document?.id ] }))
      this.bcDocumentStore.document.hidden = documentHideResponse.data[0].hidden
      this.bcFolderStore.updateDocumentDetail(this.bcDocumentStore.document.id, 'hidden', documentHideResponse.data[0].hidden)
      Toast(
        'success',
        this.$t('Document was hidden')
      ) 
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'hide')
    }
  },
}
</script>

<style lang="scss" scoped></style>
